import { EmptyState, Icons } from "construct-ui";
import moment from "moment";
import SelectCodeMasterCategoryComponent from "../../components/code-master/select-code-master-category.component";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import LocationTreeCheckboxComponent from "../../components/location/location-tree-checkbox.component";
import paginationComponent from "../../components/pagination/pagination.component";
import SelectGoodsComponent from "../../components/posm/select-goods.component";
import SelectSiteSearchInputComponent from "../../components/site/select-site-search-input.component";
import SelectWarehouseComponent from "../../components/warehouse/select-warehouse.component";
import { codeMasterType, formats, formats as FORMATS } from '../../config/constants';
import PosmModel from "../../models/posm/posm.model";
import ViewBase from "../view-base.view";
import PosmSerialDetailDialog from "./posm-serial-detail.dialog";

/**
 * Posm Serial No View
 * 
 * 
 * @author Wen Kai
 */

export default function PosmSerialTrackingView() {
    ViewBase.call(this);
    const DEFAULT_FILTER = {
        serialNo: "",
        selectedStores: [],
        selectedStoreTypes: [],
        selectedBasicModels: [],
        warehouses: [],
        locations: [],
        date: moment().format(FORMATS.ISO_DATE_FORMAT)
    }
    const DEFAULT_PAGINATION = {
        pageSize: 10,
        pageIndex: 1,
        totalItems: 0
    };
    let filters = structuredClone(DEFAULT_FILTER);
    let pagination = structuredClone(DEFAULT_PAGINATION);
    let serialList = []
    let isDetailOpen = false;
    let detailItem = {};

    let clearFilter = (e) => {
        e.preventDefault();
        filters = structuredClone(DEFAULT_FILTER);
        pagination = structuredClone(DEFAULT_PAGINATION);
    }

    let getSerialList = (e) => {
        if (!this.validateForm(e)) {
            return;
        }
        this.showLoading();
        let request = {
            storeCodeList: filters.selectedStores.map(s => s.siteId),
            warehouseIDList: filters.warehouses.map(w => w.warehouseID.toString()),
            storeTypeList: filters.selectedStoreTypes,
            goodsTypeList: filters.selectedBasicModels.map(bm => bm.name),
            locationList: filters.locations,
            serialNo: filters.serialNo,
            date: moment(filters.date).format(formats.apiDateFormat),
            pageIndex: pagination.pageIndex,
            pageSize: pagination.pageSize
        }

        PosmModel.getSerialNoList(request)
            .then(r => {
                serialList = r.data;
                pagination.totalItems = r.total;
            }).catch(e => {
                this.handleError(e);
            }).finally(_ => {
                this.hideLoading()
            })
    }

    let downloadSerialList = () => {

        this.showLoading();
        let request = {
            storeCodeList: filters.selectedStores.map(s => s.siteId),
            warehouseIDList: filters.warehouses.map(w => w.warehouseID.toString()),
            storeTypeList: filters.selectedStoreTypes,
            goodsTypeList: filters.selectedBasicModels.map(bm => bm.name),
            locationList: filters.locations,
            serialNo: filters.serialNo,
            date: moment(filters.date).format(formats.apiDateFormat),
        }

        PosmModel.downloadSerialNoList(request,)
            .catch(e => {
                this.handleError(e);
            }).finally(_ => {
                this.hideLoading()
            })
    }
    return {
        view: (vnode) => {
            return [
                m(".card.mb-3",
                    m(".card-body",
                        m('form.needs-validation[novalidate].row.g-2', { onsubmit: getSerialList },
                            m('.col-md-3.col-lg-3.position-relative',
                                m('label.form-label[for="modelCodeInput"]', this.getText('LT00001213', 'Asset Serial No')),
                                m('input#modelCodeInput', {
                                    class: 'form-control form-control-bg',
                                    placeholder: this.getText('LT00001213', 'Asset Serial No'),
                                    type: 'text',
                                    value: filters.serialNo,
                                    onchange: (e) => { filters.serialNo = e.target.value }
                                })
                            ),
                            m('.col-md-3.col-lg-3.position-relative',
                                m('label.form-label[for="brandSelection"]', this.getText('LT00000132', 'Date')),
                                m(DatePickerComponent, {
                                    id: 'datePicker',
                                    class: 'form-control',
                                    placeholder: this.getText('LT00000132', 'Date'),
                                    isRange: false,
                                    date: moment(filters.date).format(formats.dateFormat),
                                    onselect: (event) => {
                                        filters.date = event.detail.date;
                                    }
                                })
                            ),
                            m('.col-md-3.col-lg-3.position-relative',
                                m('label.form-label[for="productSelection"].mandatory', this.getText('LT00001218', 'Item Name')),
                                m(SelectGoodsComponent, {
                                    onSelect: (e) => { filters.selectedBasicModels = e; },
                                    selectedItems: filters.selectedBasicModels,
                                    required: true
                                }),
                                m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                            ),
                            m('.col-md-3.col-lg-3.position-relative',
                                m('label.form-label[for=warehouses]', this.getText('LT00001269', 'Warehouse')),
                                m(SelectWarehouseComponent, {
                                    id: 'warehouses',
                                    selectedItems: filters.warehouses,
                                    onChange: (value) => {
                                        filters.warehouses = value;
                                    }
                                })
                            ),
                            m('.col-md-3.col-lg-3.position-relative',
                                m('label.form-label[for="brandSelection"]', this.getText('LT00000071', 'Site')),
                                m(SelectSiteSearchInputComponent, {
                                    multiple: true,
                                    selectedItems: filters.selectedStores,
                                    onSelect: (e) => {
                                        filters.selectedStores = e;
                                    }
                                })
                            ),
                            m('.col-md-3.col-lg-3.position-relative',
                                m('label.form-label[for="storeTypeSelection"]', this.getText('LT00000845', 'Store Type')),
                                m(SelectCodeMasterCategoryComponent, {
                                    id: 'StoreTypes',
                                    category: codeMasterType.storeType,
                                    isMultiple: true,
                                    keyOnly: true,
                                    filterable: false,
                                    selectedItems: filters.selectedStoreTypes,
                                    onSelect: (value) => {
                                        filters.selectedStoreTypes = value;

                                    }
                                })
                            ),


                            m('.col-md-3.col-lg-3.position-relative',
                                m('label.form-label[for=locations]', this.getText('LT00000557', 'Location')),
                                m(LocationTreeCheckboxComponent, {
                                    id: 'locations',
                                    selectedCodes: filters.locations,
                                    isLevel1Expanded: true,
                                    onChange: (value) => {
                                        filters.locations = value;
                                    }
                                })
                            ),
                            m('.col-12.d-flex.justify-content-end.gap-2',
                                m('button.btn.btn-primary[type="submit"]', {
                                }, this.getText("LT00000001", "Search")),
                                m('button.btn.btn-white', {
                                    onclick: clearFilter
                                }, this.getText("LT00000031", "Clear")),
                            ),

                        )
                    )
                ),
                m('.card',
                    m('.card-body',
                        m('.row.g-2',
                            m('.col-12.d-flex.justify-content-end',
                                m('button.btn.btn-primary', {
                                    onclick: downloadSerialList,
                                    disabled: serialList.length === 0
                                },
                                    m('i.bi.bi-file-earmark-arrow-down-fill'),
                                    this.getText('LT00000018', 'Excel Download'))
                            ),
                            m('.col-12',
                                m('.table-responsive',
                                    m('table.table',
                                        m('thead',
                                            m('tr',
                                                m('th'),
                                                m('th', this.getText('LT00000413', 'S/N')),
                                                m('th', this.getText('LT00001214', 'Level 1')),
                                                m('th', this.getText('LT00001215', 'Level 2')),
                                                m('th', this.getText('LT00001216', 'Level 3')),
                                                m('th', this.getText('LT00001217', 'Level 4')),
                                                m('th', this.getText('LT00001218', 'Level 5')),
                                                m('th', this.getText('LT00001269', 'Warehouse')),
                                                m('th', this.getText('LT00000723', 'Site Code')),
                                                m('th', this.getText('LT00000144', 'Site Name')),
                                                m('th', this.getText('LT00000722', 'Region')),
                                                m('th', this.getText('LT00001219', 'State')),
                                                m('th', this.getText('LT00001220', 'City')),
                                                m('th', this.getText('LT00001221', 'District')),
                                                m('th', this.getText('LT00000845', 'Store Type')),
                                                m('th', this.getText('LT00000853', 'Channel Category')),
                                                m('th', this.getText('LT00000015', 'Status')),
                                                m('th', this.getText('LT00001222', 'Last Scanned By')),
                                                m('th', this.getText('LT00001223', 'Last Scanned Date')),
                                            )
                                        ),
                                        m('tbody',
                                            serialList.map((data,) => {

                                                return m('tr',
                                                    m('td',
                                                        m("div", {
                                                            style: {
                                                                width: "160px",
                                                                height: "120px",
                                                            }

                                                        },
                                                            data.photoString ?
                                                                m("img.h-100.w-100[role=button]", {
                                                                    style: {
                                                                        "object-fit": "cover"
                                                                    },
                                                                    src: data.photoString,
                                                                    onclick: () => {
                                                                        detailItem = data;
                                                                        isDetailOpen = true;
                                                                    }
                                                                })
                                                                :
                                                                m(EmptyState, {
                                                                    class: "position-relative cui-empty-state-icon",
                                                                    content: m("div.cui-icon", "No image uploaded"),
                                                                    icon: Icons.X_SQUARE,
                                                                    fill: true,
                                                                })
                                                        )),

                                                    m('td', m('span.cursor-text', data.serialNo)),
                                                    m('td', m('span.cursor-text', data.lvl1)),
                                                    m('td', m('span.cursor-text', data.lvl2)),
                                                    m('td', m('span.cursor-text', data.lvl3)),
                                                    m('td', m('span.cursor-text', data.lvl4)),
                                                    m('td', m('span.cursor-text', data.lvl5)),
                                                    m('td', m('span.cursor-text', data.warehouseName)),
                                                    m('td', m('span.cursor-text', data.storeCode)),
                                                    m('td', m('span.cursor-text', data.storeName)),
                                                    m('td', m('span.cursor-text', data.region)),
                                                    m('td', m('span.cursor-text', data.state)),
                                                    m('td', m('span.cursor-text', data.city)),
                                                    m('td', m('span.cursor-text', data.district)),
                                                    m('td', m('span.cursor-text', data.storeType)),
                                                    m('td', m('span.cursor-text', data.channelCategory)),
                                                    m('td', data.isScrap ? m('.badge.rounded-pill.danger-bg-status', "Scrapped") : m('.badge.rounded-pill.active', "Active")),
                                                    m('td', m('span.cursor-text', data.registeredBy)),
                                                    m('td', m('span.cursor-text', data.registeredDate)),
                                                );
                                            })
                                        )
                                    )
                                )
                            )
                        ),
                        m('.col-12', m(paginationComponent,
                            {
                                currentPage: pagination.pageIndex,
                                pageSize: pagination.pageSize,
                                totalItems: pagination.totalItems,
                                onPageChanged: (pageIndex) => {
                                    pagination.pageIndex = pageIndex;
                                    getSerialList();
                                },
                                onPageSizeChanged: (_, pageSize) => {
                                    pagination.pageIndex = DEFAULT_PAGINATION.pageIndex
                                    pagination.pageSize = pageSize;
                                    getSerialList();
                                }
                            }
                        ))
                    )
                ),
                m(PosmSerialDetailDialog, {
                    isOpen: isDetailOpen,
                    onClose: () => { isDetailOpen = false; },
                    displayItem: detailItem
                }),
                this.getBaseViews()
            ]
        }
    }
}
